<script>
  import { randomInt } from '@mediahackza/utilities'
  let dataTwo
  let fullyVaccinatedPercent = '0%'
  let fullyVaccinatedPer = 0
  let ri = randomInt(1000, 10000000)
  let reponse = fetch(
    `https://coronavirus.mediahack.co.za/api/vaccinations-bhekisisa.php?r=${ri}`
  )
    .then((response) => response.json())
    .then((response) => {
      dataTwo = response
      console.log(dataTwo)

      fullyVaccinatedPercent = dataTwo[9]['% of adults fully vaccinated']
      fullyVaccinatedPer = fullyVaccinatedPercent.replace('%', '')
    })
  import { formatThousands, calculateTime } from './functions'
  import { target, percent } from './config'

  import { utcYear } from 'd3-time'
  export let nationalData
  let currentData = nationalData[0]
  let vaccinatedTotal =
    +currentData.Pfizer_second_dose + +currentData.total_jandj
  let toBeVaccinated = target - vaccinatedTotal

  let currentAverage = (+currentData.seven_day_average).toFixed(0)

  let jandjdays = (toBeVaccinated / currentAverage).toFixed(0)

  let pfizerdays = (
    ((toBeVaccinated -
      (+currentData.Pfizer_first_dose - currentData.Pfizer_second_dose)) *
      2 +
      (+currentData.Pfizer_first_dose - currentData.Pfizer_second_dose)) /
    currentAverage
  ).toFixed(0)
  let jandjtime = calculateTime(jandjdays)
  let pfizertime = calculateTime(pfizerdays)
  function calculateTimeString(time) {
    let str = ''
    // years
    if (time['years'] === 1) {
      str += '1 year '
    } else if (time['years' > 1]) {
      str += time['years'] + ' years '
    }
    //months
    if (time['months'] === 1) {
      str += '1 month '
    } else if (time['months' > 1]) {
      str += time['months'] + ' months '
    }
    //days
    if (time['days'] === 1) {
      str += '1 day '
    } else if (time['days' > 1]) {
      str += time['days'] + ' days '
    }
  }

  // let jandjtimestring = calculateTimeString(jandjtime)
</script>

<div class="calc">
  <div class="chart-title">
    How long will it take to vaccinate 67% of South Africans?
  </div>
  <div class="notes">
    Target = {target}<br />
    Pfizer_first_dose = {currentData.Pfizer_first_dose}<br />
    Pfizer_second_dose = {currentData.Pfizer_second_dose}<br />
    JnJ_vaccines = {currentData.JnJ_vaccines}<br />
    Sisonke_JnJ_total = {currentData.Sisonke_JnJ_total}<br />
    vaccinatedTotal = {vaccinatedTotal}<br />
    toBeVaccinated = {toBeVaccinated}<br />
    pfizerdays = {pfizerdays}<br />
    jandjdays = {jandjdays}<br />
    currentAverage = {currentAverage}
  </div>
  <div class="calc-weekly">
    <div class="current-avg-label">
      So far <span class="highlight"
        >{formatThousands(currentData.fully_vaccinated)}</span
      >
      people in SA have been fully vaccinated
      <span class="highlight">({fullyVaccinatedPercent} of adults)</span>
    </div>
    <div class="current-avg-label">
      SA has administered an average of
      <span class="highlight">{formatThousands(currentAverage)}</span>
      vaccinations per day over the past week. At this rate it will take this long
      to vaccinate the remaining portion of the target population.
    </div>
  </div>

  <div class="calculator-boxes">
    <div class="calculator-box">
      <div class="logos">
        <img src="assets/jnj.png" class="vaxlogos jjlogo" alt="J&J Logo" />
      </div>
      <!-- {jandjdays} days<br /> -->
      <!-- J&J Years -->
      {#if jandjtime['years'] === 1}
        {jandjtime['years']} year
      {:else if jandjtime['years'] > 1}
        {jandjtime['years']} years
      {/if}
      <!-- J&J Months -->
      {#if jandjtime['months'] === 1}
        {jandjtime['months']} month
      {:else if jandjtime['months'] > 1}
        {jandjtime['months']} months
      {/if}
      <!-- J&J Days -->
      {#if jandjtime['days'] === 1}
        {jandjtime['days']} days
      {:else if jandjtime['days'] > 1}
        {jandjtime['days']} days
      {/if}
      <div class="calculator-note">J&J requires a single dose</div>
    </div>
    <div class="calculator-box">
      <div class="logos">
        <img
          src="assets/pfizer-800.png"
          class="vaxlogos pflogo"
          alt="Pfizer Logo"
        />
      </div>
      <!-- {pfizerdays} days<br /> -->
      <!-- J&J Years -->
      {#if pfizertime['years'] === 1}
        {pfizertime['years']} year
      {:else if pfizertime['years'] > 1}
        {pfizertime['years']} years
      {/if}
      <!-- J&J Months -->
      {#if pfizertime['months'] === 1}
        {pfizertime['months']} month
      {:else if pfizertime['months'] > 1}
        {pfizertime['months']} months
      {/if}
      <!-- J&J Days -->
      {#if pfizertime['days'] === 1}
        {pfizertime['days']} days
      {:else if pfizertime['days'] > 1}
        {pfizertime['days']} days
      {/if}
      <div class="calculator-note">
        Pfizer requires two doses, typically six weeks apart
      </div>
    </div>
  </div>
  <div class="disclaimer">
    These estimates are based on the current daily average number of doses and
    do no not account for likely drop-offs in daily rates.
  </div>
</div>

<style>
  .notes {
    margin-bottom: 20px;
    color: indianred;
    display: none;
  }
  .disclaimer {
    font-size: 80%;
    margin-top: 20px;
    color: gray;
    line-height: 110%;
  }
  .current-avg-note {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .current-avg-number {
    font-size: 150%;
    font-weight: 700;
    color: var(--darkgreen);
  }
  .calculator-boxes {
    margin-top: 30px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
  }
  .calculator-box {
    font-size: 120%;
    font-weight: 700;
    background: var(--blue700);
    padding: 5px;
    border-radius: 10px;
    color: #fff;
    padding-bottom: 10px;
  }
  .calc {
    font-family: 'Titillium Web', Arial, Helvetica, sans-serif;
    border: solid 1px var(--darkgreen);
    background: var(--lightgreen);
    padding: 20px;
  }
  /* img.vaxlogos {
    width: 100px;
  } */
  img.jjlogo {
    width: 170px;
    margin-top: 5px;
  }
  img.pflogo {
    width: 50px;
    margin-top: 8px;
  }
  .logos {
    min-height: 50px;
  }
  .calculator-note {
    font-weight: 400;
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-size: 70%;
    line-height: 110%;
    margin-top: 10px;
  }

  @media (max-width: 600px) {
    .calculator-boxes {
      grid-template-columns: 1fr;
    }
  }
</style>
